import { useQuery } from 'react-query';
import { useMemo, useState } from 'react';
import { useDebouncedCallback } from 'beautiful-react-hooks';

import { createRestApi, DefaultGetAllResponse } from '~/App/Api/rest';

interface LoadDataParams {
  query?: string;
}

export interface RestApiOptions {
  debounceTime?: number;
}

export default function useRestApi<T = unknown>(
  url: string,
  { debounceTime = 500 }: RestApiOptions = {}
) {
  const api = useMemo(() => createRestApi<T>(url), [url]);

  const emptyResponse: DefaultGetAllResponse<T> = {
    data: [],
    from: 0,
    to: 0,
    current_page: 0,
    first_page_url: String(),
    per_page: 0,
  };

  const [params, setParams] = useState<LoadDataParams>();

  const { data, isLoading } = useQuery([url, { params }], () =>
    api.getAll(params)
  );

  const search = useDebouncedCallback(
    (query?: string) => {
      if (query && query.length >= 3) {
        setParams({ query });
      } else {
        setParams({});
      }
    },
    [setParams],
    debounceTime
  );

  return [data ?? emptyResponse, api, { isLoading }, search] as const;
}
